export default "__VITE_ASSET__5139dc6f__"